import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
// Must come AFTER bootstrap: it overrides variables bootstrap sets on the rule itself.
import '@/shared/dark-bootstrap-overrides.css';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
import Router from './Router';
import store from '@/stores';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import GlobalStyles from './globalStyles';
import RechartStyles from './rechartStyles';
import NotificationStyles from './notificationStyles';
import CalendarStyles from './calendarStyles';
import { RootState } from '@/stores';

i18n.init(i18nextConfig);

const ThemeComponent = ({ children }: { children: ReactNode }) => {
    const { mode, direction, shadow, border } = useSelector((state: RootState) => ({
        mode: state.theme?.className,
        direction: state.rtl?.direction,
        shadow: state.shadow?.className,
        border: state.border?.className,
    }));

    const theme = createTheme({
        palette: {
            // Narrowed rather than passed straight through: the reducer only ever
            // stores 'dark' or 'light', but it is typed as `string`, and MUI's
            // `palette.type` is the `'light' | 'dark'` union. The old
            // `useSelector((state: any) => …)` hid the mismatch entirely — typing
            // the selector is what surfaced it.
            type: mode === 'light' ? 'light' : 'dark',
        },
    });

    return (
        <MuiThemeProvider theme={theme}>
            <ThemeProvider
                theme={{
                    mode,
                    direction,
                    shadow,
                    border,
                }}
            >
                <GlobalStyles />
                <NotificationStyles />
                <RechartStyles />
                <TimepickerStyles />
                <CalendarStyles />
                {children}
            </ThemeProvider>
        </MuiThemeProvider>
    );
};

const ConnectedThemeComponent = ThemeComponent;

const App = () => {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                    {/* <WalletConnectProvider> */}
                    <ConnectedThemeComponent>
                        {/* <LoadScript loadingElement={<Loading loading />} googleMapsApiKey=""> */}
                        <ScrollToTop>
                            <Router />
                        </ScrollToTop>
                        {/* </LoadScript> */}
                    </ConnectedThemeComponent>
                    {/* </WalletConnectProvider> */}
                </I18nextProvider>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
